/* eslint-disable @typescript-eslint/no-unused-expressions */
import { progressApi } from "utilities/Axios";
import { getExtractedPath } from "utilities/extractedPath";

const extractedPath = getExtractedPath();

function subtractHours(date: any) {
  date.setHours(date.getHours() - 720);
  return date;
}

const dateNow = new Date();
const dateTime = subtractHours(dateNow);

export const getAllTags = () => {
  return progressApi.get(`/TagMeta/GetAllTags${extractedPath}`);
};

export const getTagData = (
  ids: any,
  dateTime?: string,
) => {
  let url = `Dashboard/GetTagData${extractedPath}`;
  dateTime ? (url += `?dateTime=${dateTime}`) : null;
  return progressApi.post(url, ids);
};

export const mapEquipmentTag = (tags: any) => {
  return progressApi.post(`/TagMeta/MapEquipmentTag${extractedPath}`, tags);
};

export const getAllTagsWithParents = () => {
  return progressApi.get(`/TagMeta/GetAllTagsWithParent${extractedPath}`);
};

export const createTag = (tag: any) => {
  return progressApi.post(`/TagMeta/CreateTag${extractedPath}`, tag);
};

export const updateTag = (tag: any) => {
  return progressApi.post(`/TagMeta/UpdateTag${extractedPath}`, tag);
};

export const resetTag = (id: any) => {
  return progressApi.get(`/TagMeta/ResetTagRange${extractedPath}?id=${id}`);
};

export const uploadTag = (data: any, signal: any) => {
  return progressApi.post(`TagData/Upload${extractedPath}`, data, { signal });
};

export const deleteTag = (id: any) => {
  return progressApi.get(`/TagMeta/DeleteTag${extractedPath}?id=${id}`);
};

export const getTrainsByPlantId = (id: any) => {
  return progressApi.get(`/TagMeta/GetTrainsByPlantId${extractedPath}?id=${id}`);
};

export const disableTag = (tagId: number, status: any) => {
  return progressApi.post(
    `/TagMeta/SetTagDisabled${extractedPath}?tagId=${tagId}&isDisabled=${status}`
  );
};

export const getTagsByEquipmentsId = (equipmentId: any) => {
  return progressApi.get(`/TagMeta/GetTagsByEquipmentsId${extractedPath}?id=${equipmentId}`);
};

export const downloadTag = (id: any) => {
  return progressApi.get(`/TagData/DownloadTagData${extractedPath}?id=${id}`);
};

export const clearTag = (id: any) => {
  return progressApi.get(`/TagData/ClearTagData${extractedPath}?id=${id}`);
};

export const getTagsByUnitId = (unitId: any) => {
  return progressApi.get(`/TagMeta/GetTagsByUnitId${extractedPath}?id=${unitId}`);
};

export const getTagsByTrainId = (unitId: any) => {
  return progressApi.get(`/TagMeta/GetTagsByTrainId${extractedPath}?id=${unitId}`);
};